module.exports = __webpack_public_path__ + "home-main.png?9ea3db7466972b7c5f3c927d696ad935";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home-main.png
// module id = 46
// module chunks = 0